import {Component} from '@angular/core';

@Component({
  selector: 'clv-tleft-head',
  template: `<ng-content></ng-content>`,
  styles: [`
  `]
})
export class ClvTleftHeadComponent {

}
